// extracted by css-extract-rspack-plugin
export default {"shimmer":"_bb9c8d0c","shimmerLoadingBackground":"_6b1e6164"};